import { Yup } from '../../../common/CommonExport';

export const createUserValidationSchema = Yup.object().shape({
    roleName: Yup.string().required('User name  is required'),
    officialEmail: Yup.string().required('Email is required'),
    role: Yup.string().required('Role is required'),
});
